import { CREATE_RETURN_ERROR, CREATE_RETURN_SUCCESS, CREATE_RETURN_REQUEST } from '../constants/ActionTypes'

export default function isReturningOrder(state = false, action) {
    switch (action.type) {
        case CREATE_RETURN_REQUEST:
            return true

        case CREATE_RETURN_SUCCESS:
        case CREATE_RETURN_ERROR:
            return false
        default:
            return state
    }
}
